// PAQUETES
import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";
// COMPONENTES
import ZonaCargando from "../alertas/zonaCargando";
import HelmetSEO from "../../componentesEspeciales/helmetSEO";
import Registro from "./registrar";

function Referido(){

    const { referidoPor } = useParams(); // username del usuario que invitó: /:referidoPor/te-invito-a-zervicy
    const navigate = useNavigate();
    const [cargando, setCargando] = useState(true);
    const [existe, setExiste] = useState(null);
    const [datosReferido, setDatosReferido] = useState(null);
    const [mostrarRegistro, setMostrarRegistro] = useState(false);

    useEffect(() => {
        if(!referidoPor){
            navigate("/registrar", { replace: true });
            return;
        }

        (async () => {
            try{
                setCargando(true);

                const res = await axios.post("/verificar-existe-usuario", {
                    params: { username: referidoPor }
                });

                setExiste(Boolean(res?.data?.existe));
                setDatosReferido(res?.data?.usuario || null);
            }
            catch(err){
                console.log("error verificando usuario referido:", err);
                setExiste(false);
            }
            finally{
                setCargando(false);
            }
        })();
    }, [referidoPor, navigate]);

    function nombreReferido(){
        const nombre = datosReferido?.nombre || "";
        const apellido = datosReferido?.apellido || "";
        const nombreCompleto = `${nombre} ${apellido}`.trim();
        return nombreCompleto || referidoPor;
    }

    function avatarReferido(){
        return datosReferido?.avatar || "/imagenes/marca/avatar.png";
    }

    // Una vez el usuario decide registrarse, mostramos el formulario de registro ya existente
    // en esta misma ruta, así "referidoPor" sigue llegando por useParams sin duplicar lógica.
    if(mostrarRegistro){
        return <Registro />;
    }

    if(cargando){
        return <ZonaCargando />;
    }

    if(existe === false){
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: "linear-gradient(135deg, var(--azul-logo-fondo), var(--azul-medio))" }}>
                <div className="card border-0 shadow-lg rounded-4 text-center p-4 m-3" style={{ maxWidth: "420px" }}>
                    <div className="mb-3">
                        <i className="bi bi-person-x" style={{ fontSize: "48px", color: "var(--naranja-cta)" }} />
                    </div>

                    <h1 className="h4 fw-bold mb-2">Este usuario no existe</h1>
                    <p className="text-secondary mb-4">
                        El enlace de invitación no es válido o el usuario que te invitó ya no está disponible.
                    </p>

                    <button
                        type="button"
                        className="btn btn-primary rounded-pill px-4 py-2 fw-semibold"
                        onClick={() => navigate("/")}
                    >
                        Volver a Zervicy
                    </button>
                </div>
            </div>
        );
    }

    return(
        <>
            <HelmetSEO
                titulo={`${nombreReferido()} te invitó a Zervicy`}
                descripcion={`${nombreReferido()} te invitó a unirte a Zervicy, el marketplace donde puedes contratar u ofrecer servicios de confianza en Colombia.`}
                imagen={avatarReferido()}
            />

            <div className="bg-white">

                {/* ── HERO INVITACIÓN ─────────────────────────────────── */}
                <section className="position-relative overflow-hidden" style={{ background: "linear-gradient(135deg, var(--azul-logo-fondo) 0%, var(--azul-medio) 55%, var(--azul-logo-claro) 100%)" }}>
                    <div className="container py-5">
                        <div className="d-flex justify-content-center mb-4">
                            <a href="/">
                                <img src="/imagenes/marca/zervicyblancohorizontal.png" alt="Zervicy" height="42" />
                            </a>
                        </div>

                        <div className="row justify-content-center text-center">
                            <div className="col-12 col-lg-8 text-white">
                                <img
                                    src={avatarReferido()}
                                    alt={nombreReferido()}
                                    className="rounded-circle object-fit-cover border border-4 border-white shadow-sm mb-3"
                                    style={{ width: "88px", height: "88px" }}
                                />

                                <span className="badge rounded-pill px-3 py-2 mb-3 d-block mx-auto" style={{ backgroundColor: "var(--naranja-cta)", maxWidth: "fit-content" }}>
                                    Invitación personal
                                </span>

                                <h1 className="display-6 fw-bold mb-3">
                                    ¡<b>{nombreReferido()}</b> te invitó a unirte a Zervicy!
                                </h1>
                                <p className="lead mb-4" style={{ color: "rgba(var(--blanco-rgb), .85)" }}>
                                    Zervicy es el marketplace donde puedes <strong>contratar u ofrecer servicios de todo tipo</strong> — aseo, mascotas, belleza, diseño, clases y mucho más — conectando personas con profesionales de confianza en Colombia.
                                </p>

                                <button
                                    type="button"
                                    className="btn btn-lg rounded-pill px-5 fw-semibold"
                                    style={{ backgroundColor: "var(--naranja-cta)", color: "white", border: "none" }}
                                    onClick={() => setMostrarRegistro(true)}
                                >
                                    <i className="bi bi-person-plus me-2"></i>
                                    Crear mi cuenta gratis
                                </button>

                                <p className="mt-3 mb-0" style={{ fontSize: "13px", color: "rgba(var(--blanco-rgb), .7)" }}>
                                    ¿Ya tienes cuenta? <a href="/iniciar-sesion" className="text-white text-decoration-underline">Inicia sesión</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ── QUÉ PUEDES HACER ───────────────────────────────────── */}
                <section className="py-5" style={{ backgroundColor: "var(--color-bg-surface-alt)" }}>
                    <div className="container">
                        <div className="text-center mb-4">
                            <h2 className="h3 fw-bold mb-2" style={{ color: "var(--color-text-primary)" }}>¿Qué puedes hacer en Zervicy?</h2>
                            <p className="text-muted">Todo desde una sola cuenta, gratis.</p>
                        </div>

                        <div className="row g-4 justify-content-center">
                            <div className="col-12 col-md-5">
                                <div className="card border-0 shadow-sm rounded-4 h-100 p-4 text-center">
                                    <div className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center"
                                        style={{ width: 64, height: 64, backgroundColor: "rgba(var(--azul-logo-claro-rgb), 0.1)", color: "var(--azul-logo-claro)" }}>
                                        <i className="bi bi-search fs-3"></i>
                                    </div>
                                    <h4 className="fw-bold mb-2" style={{ color: "var(--color-text-primary)" }}>Contratar servicios</h4>
                                    <p className="text-muted mb-0">
                                        Busca entre cientos de profesionales verificados. Compara, reserva y paga de forma segura.
                                    </p>
                                </div>
                            </div>

                            <div className="col-12 col-md-5">
                                <div className="card border-0 shadow-sm rounded-4 h-100 p-4 text-center">
                                    <div className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center"
                                        style={{ width: 64, height: 64, backgroundColor: "rgba(var(--naranja-cta-rgb), 0.1)", color: "var(--naranja-cta)" }}>
                                        <i className="bi bi-briefcase fs-3"></i>
                                    </div>
                                    <h4 className="fw-bold mb-2" style={{ color: "var(--color-text-primary)" }}>Ofrecer tus servicios</h4>
                                    <p className="text-muted mb-0">
                                        Publica lo que sabes hacer, define tus precios y recibe reservas y pagos directamente.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ── CTA FINAL ─────────────────────────────────────────── */}
                <section className="py-5 text-center" style={{ background: "linear-gradient(135deg, var(--azul-logo-fondo), var(--azul-medio))", color: "white" }}>
                    <div className="container">
                        <h2 className="h3 fw-bold mb-2">Únete a Zervicy hoy</h2>
                        <p className="mb-4" style={{ color: "rgba(var(--blanco-rgb), .8)" }}>
                            <b>{nombreReferido()}</b> ya confía en Zervicy. Crea tu cuenta y descubre por qué.
                        </p>
                        <button
                            type="button"
                            className="btn btn-lg rounded-pill px-5 fw-semibold"
                            style={{ backgroundColor: "var(--naranja-cta)", color: "white", border: "none" }}
                            onClick={() => setMostrarRegistro(true)}
                        >
                            <i className="bi bi-arrow-right-circle me-2"></i>
                            Crear cuenta gratis
                        </button>

                        <p className="mt-4 mb-0">
                            <Link to="/como-funciona" className="text-white text-decoration-underline">
                                <i className="bi bi-question-circle me-1"></i>
                                ¿Cómo funciona Zervicy?
                            </Link>
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Referido;
